module.exports = __webpack_public_path__ + "static/media/Omkar_Nagwekar.c778703a.jpg";